<script setup lang="ts">
import type { BeltColor } from '@@/bits/belt_colors'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { computed } from 'vue'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { storeToRefs } from 'pinia'

const props = defineProps<{
  color: BeltColor
  isDarkMode: boolean
}>()

const BACKGROUND_IMAGE_WIDTH = 1440
const BACKGROUND_IMAGE_HEIGHT = 173
const BACKGROUND_IMAGE_ASPECT_RATIO = BACKGROUND_IMAGE_WIDTH / BACKGROUND_IMAGE_HEIGHT

const windowSizeStore = useWindowSizeStore()
const { windowWidth } = storeToRefs(windowSizeStore)

const backgroundIllustrationUrl = computed(() => {
  return `https://padlet.net/dashboard/belt/v1_profile_background_illustration_${props.color}_${props.isDarkMode ? 'dark' : 'light'}.svg`
})
</script>

<template>
  <div v-if="color !== 'white'" class="relative w-full h-full overflow-hidden">
    <ImageThumbnail
      :src="backgroundIllustrationUrl"
      :original-image-width="BACKGROUND_IMAGE_WIDTH"
      :original-image-height="BACKGROUND_IMAGE_HEIGHT"
      :width="windowWidth"
      :aspect-ratio="BACKGROUND_IMAGE_ASPECT_RATIO"
      :resize-strategy="'fit'"
      alt=""
    />
  </div>
</template>
